import { render, staticRenderFns } from "./dadosRMForm.vue?vue&type=template&id=2c39bce4&"
import script from "./dadosRMForm.vue?vue&type=script&lang=js&"
export * from "./dadosRMForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports